import { render, staticRenderFns } from "./inc.vue?vue&type=template&id=3f4b4215"
import script from "./inc.vue?vue&type=script&lang=js"
export * from "./inc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports